import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import ThemeRegistry from "@styles/ThemeRegistry.tsx";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <ThemeRegistry>
            <App />
        </ThemeRegistry>
    </StrictMode>
);
